import { BifLoaderService } from '@common/libs/bitforce/core/services/loader/bitf-loader.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoaderService extends BifLoaderService {}
